export const SELLERS = "seller_id";
export const INVENTORY = "inventory_id";
export const ORDER_OR_GROUP_ID = "s";
